var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconclose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  fillRule: "evenodd",
  d: "m13.697 12 5.152-5.152a1.199 1.199 0 1 0-1.697-1.697L12 10.302 6.85 5.151a1.199 1.199 0 1 0-1.697 1.697l5.151 5.151-5.151 5.152a1.199 1.199 0 1 0 1.696 1.697L12 13.696l5.152 5.152a1.197 1.197 0 0 0 1.697 0c.469-.47.469-1.228 0-1.697z",
  clipRule: "evenodd"
})));
export { SvgIconclose as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.close.0e3b021c.svg";